module.exports = __webpack_public_path__ + "img/support_a7.b3f90e95.png";